/* eslint import/no-default-export: off */
import { NavGroup, NavItem } from "@portaljs/core";
import clientPromise from "../lib/mddb.mjs"
import fs from "fs";
import parse from "../lib/markdown"
import { GetStaticPaths, GetStaticProps, GetStaticPropsResult } from "next";
import MdxPage from "@/components/MdxPage";
import computeFields from "@/lib/computeFields";
import getMdList from "@/lib/getMdList";

export default function Page({ source, meta }: any) {
  source = JSON.parse(source);

  return (
    <div className="px-3 md:px-0 py-4">
      <MdxPage source={source} frontMatter={meta} />
    </div>
  );
}

export const getStaticProps: GetStaticProps = async ({
  params,
}): Promise<GetStaticPropsResult<any>> => {
  const urlPath = params?.slug ? (params.slug as string[]).join("/") : "/";

  const mddb = await clientPromise;
  const dbFile = await mddb.getFileByUrl(urlPath);
  const filePath = dbFile!.file_path;
  const frontMatter = dbFile!.metadata ?? {};

  const source = fs.readFileSync(filePath, { encoding: "utf-8" });
  const { mdxSource } = await parse(source, "mdx", {});

  // TODO temporary replacement for contentlayer's computedFields
  const frontMatterWithComputedFields = await computeFields({
    frontMatter,
    urlPath,
    filePath,
    source,
  });

  let allPages = {};

  if (frontMatterWithComputedFields.layout === "article") {
    allPages = await getMdList("showcase/case-studies");
  }
  else if (frontMatterWithComputedFields.layout === "blog" || frontMatterWithComputedFields.layout === "blogPost") {
    allPages = await getMdList("blog");
  }

  const meta = { ...frontMatterWithComputedFields, allPages: allPages };

  const siteMap: Array<NavGroup | NavItem> = [];

  if (frontMatterWithComputedFields?.showSidebar) {
    const allPages = await mddb.getFiles({ extensions: ["md", "mdx"] });
    const pages = allPages.filter((p) => !p.metadata?.isDraft);
    pages.forEach((page) => {
      addPageToSitemap(page, siteMap);
    });
  }

  return {
    props: {
      source: JSON.stringify(mdxSource),
      meta: meta,
      siteMap,
    },
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  const mddb = await clientPromise;
  const allDocuments = await mddb.getFiles({ extensions: ["md", "mdx"] });

  const paths = allDocuments
    .filter((page) => page.metadata?.isDraft !== true)
    .map((page) => {
      const parts = page.url_path!.split("/");
      return { params: { slug: parts } };
    });
  return {
    paths,
    fallback: false,
  };
};

function addPageToSitemap(page: any, sitemap: Array<NavGroup | NavItem>) {
  const urlDecoded = decodeURI(page.url_path);
  const urlParts = urlDecoded!.split("/").filter((part) => part);
  // don't add home page to the sitemap
  if (urlParts.length === 0) return;
  // top level, root pages
  if (urlParts.length === 1) {
    /* let rootGroup = sitemap.find((g) => g.name === "root");
     * if (!rootGroup) {
     *     rootGroup = { name: "root", path: "/", level: 0, children: [] };
     *     sitemap.push(rootGroup);
     * }
     * rootGroup.children.push({
     *     name: page.metadata?.title || urlParts[0],
     *     href: page.url_path,
     * }); */
    sitemap.push({
      name: page.metadata?.title || urlParts[0],
      href: page.url_path,
    });
  } else {
    // /blog/blogtest
    const nestingLevel = urlParts.length - 1; // 1
    let currArray: Array<NavItem | NavGroup> = sitemap;

    for (let level = 0; level <= nestingLevel; level++) {
      if (level === nestingLevel) {
        currArray.push({
          name: page.metadata?.title || urlParts[level],
          href: page.url_path,
        });
        continue;
      }

      const matchingGroup = currArray
        .filter(isNavGroup)
        .find(
          (group) =>
            group.path !== undefined && decodeURI(page.url_path).startsWith(group.path)
        );
      if (!matchingGroup) {
        const newGroup: NavGroup = {
          name: capitalize(urlParts[level]),
          path: urlParts.slice(0, level + 1).join("/"),
          level,
          children: [],
        };
        currArray.push(newGroup);
        currArray = newGroup.children;
      } else {
        currArray = matchingGroup.children;
      }
    }
  }
}

function isNavGroup(item: NavItem | NavGroup): item is NavGroup {
  return (item as NavGroup).children !== undefined;
}

function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
